<template>
    <div>
        <app-toggle-field
            :required="false"
            class="reset"
            :classes="{ input: { 'input--composer': true } }"
            v-model="content"
        />
    </div>
</template>

<script>
    import Api from '@/api/index.js';

    import ToggleField from '@/components/fields/inputs/Toggle';

    export default {
        props: {
            block: {
                type: String,
                required: true
            },
            locale: {
                required: false
            },
            value: {
                required: false
            }
        },

        components: {
            'app-toggle-field': ToggleField,
        },

        data: () => ({
            content: false
        }),

        mounted() {
            this.content = this.value ? this.value : false;
        },

        methods: {
            getValues() {
                // API call
                return Api.request('post', `composer/global`, {
                    block: this.block,
                    locale: this.locale
                })
                    .then( ({data}) => {
                        if (data) {
                            this.$emit('onGetValues', data.values);
                        }
                    } );
            }
        },

        watch: {
            content() {
                if (this.content) {
                    this.getValues();
                }

                this.$emit('input', this.content);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Fields/Global.vue